<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
    >
      <template v-slot:displayAccount="{ row }">
        <span>{{ row.bankAccountName }}</span>
        <br />
        <span>{{ row.bankAccountNo }}</span>
      </template>
      <template v-slot:displayBankType="{ row }">
        <span>{{ row.v_bankAccountType }}</span>
        <br />
        <span>{{ row.v_bankAccountKind }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  computed: {
    height() {
      const minHeight = 500
      const height = this.tableHeight
      return height < minHeight ? minHeight : height
    },
  },
}
</script>
